import {
  SET_DATA,
  SET_ENDPOINT,
  SET_STOREDATA,
  SET_CURRENCY_SYMBOL,
  SET_ORDER_DATA,
  SET_USER_LOACATION,
  SET_SEARCH_QUERY,
  SET_THEME_COLOR,
  SET_APP_CONFIGS,
  IS_FETCHING_APP_CONFIGS,
} from "./types";

export function setUserData(data) {
  return {
    type: SET_DATA,
    data,
  };
}

export function setEndPoint(data) {
  return {
    type: SET_ENDPOINT,
    data,
  };
}

export function setStoreData(data) {
  return {
    type: SET_STOREDATA,
    data,
  };
}

export function setCurrencySymbol(symbol) {
  return {
    type: SET_CURRENCY_SYMBOL,
    data: symbol,
  };
}

export function setOrderData(data) {
  return {
    type: SET_ORDER_DATA,
    data,
  };
}

export function setUserLocation(data) {
  return {
    type: SET_USER_LOACATION,
    data,
  };
}

export function setSearchQuery(text) {
  return {
    type: SET_SEARCH_QUERY,
    data: text,
  };
}

export function setThemeColor(color) {
  return {
    type: SET_THEME_COLOR,
    data: color,
  };
}

export function setFetchingAppConfig(data) {
  return {
    type: IS_FETCHING_APP_CONFIGS,
    data,
  };
}

export function setAppConfigs(data, country) {
  return {
    type: SET_APP_CONFIGS,
    data: { data, country },
  };
}
